import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { useGetBusinessPlanPDFBinaryData } from 'services/businessPlan/hooks/useGetBusinessPlanPDFBinaryData';

import { Loader } from 'components/_basic/Loader/Loader';
import { NavigateToErrorPage } from 'components/_basic/NavigateToErrorPage';

export const PDFViewPage: FC = () => {
  const { id = '' } = useParams();
  const { data: blob, isError, isFetching } = useGetBusinessPlanPDFBinaryData(id);

  useEffect(() => {
    if (!isFetching && !isError && blob) {
      const blobUrl = URL.createObjectURL(blob);
      window.location.href = blobUrl;
    }
  }, [isFetching, isError, blob]);

  if (isFetching)
    return (
      <>
        <Helmet>
          <script type="text/javascript" defer>
            {`
            window.dataLayer = window.dataLayer || [];
            let userId = '';
            try {
              const userStore = localStorage.getItem('user-store');
              if (userStore) {
                const parsed = JSON.parse(userStore);
                userId = parsed?.state?.authUser?.id || '';
                dataLayer.push({ user_id: userId });
              }
            } catch (e) {
              console.error('Failed to parse user-store:', e);
            }
          `}
          </script>
        </Helmet>
        <Loader />
      </>
    );

  if (isError) return <NavigateToErrorPage errorCode="404" replace />;

  return null;
};
